import {Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './Badge.classes'
import type {BadgeProps} from './Badge.types'

export function Badge({label, className, isDisabled = false}: BadgeProps) {
  return (
    <div
      className={clsx(
        classes.root,
        isDisabled ? classes.disabled : classes.active,
        className,
      )}
    >
      <Typography
        color="invert"
        group="normal"
        thickness="medium"
        variant="caption2"
      >
        {label}
      </Typography>
    </div>
  )
}
